module.exports = __webpack_public_path__ + "static/img/aomenappointment.a53986b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aomenappointment.jpg
// module id = oocn
// module chunks = 0